import useModuleContext from "./useModuleContext";

const shouldAutoLoadByBreakpoint = (index?: number) => {
  if (index === undefined) return false;
  // if it is 0 then it wasn't used in a pagebuilder and can be autoLoaded
  // 1 and 2 are the first two items in that pagebuilder for the specific breakpoint
  return index <= 2;
};

/**
 * this hook checks if the current module is in the first 2 in the pagebuilder for any breakpoint.
 * Anything further in the pagebuilder should lazy load
 * @returns this returns true if it should lazy load, false if it should load automatically
 */
const useLazyLoadCheck = () => {
  const { indexInPageBuilder } = useModuleContext();

  // it should auto load if it is first items in page builder or outside the page builder
  const shouldAutoLoad =
    shouldAutoLoadByBreakpoint(indexInPageBuilder?.desktop) ||
    shouldAutoLoadByBreakpoint(indexInPageBuilder?.tablet) ||
    shouldAutoLoadByBreakpoint(indexInPageBuilder?.mobile);

  return !shouldAutoLoad;
};

export default useLazyLoadCheck;
